import { render, staticRenderFns } from "./AddonToggle.vue?vue&type=template&id=e2a0af86&"
import script from "./AddonToggle.vue?vue&type=script&lang=js&"
export * from "./AddonToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports